import { Dispatch, SetStateAction, useContext, useState } from 'react';
import { ApolloClient, OperationVariables } from '@apollo/client';
import { useQuery } from '@apollo/client/react';
import { SortDirection } from '@mui/material';
import * as R from 'ramda';

import { GET_USER_GROUPS_FOR_USER } from '@atom/graph/userGroup';
import {
  UserUserGroup,
  UserUserGroupsConnection,
} from '@atom/types/userGroups';

import UserContext from '../UserContext';

export interface GroupsTabProps {
  groups: UserUserGroup[];
  refetchGroups: (
    variables?: Partial<OperationVariables>,
  ) => Promise<
    ApolloClient.QueryResult<{ userUserGroups: UserUserGroupsConnection }>
  >;
  loadingGroups: boolean;
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  limit: number;
  setLimit: Dispatch<SetStateAction<number>>;
  sortDirection: SortDirection;
  setSortDirection: Dispatch<SetStateAction<SortDirection>>;
  sortBy: string;
  setSortBy: Dispatch<SetStateAction<string>>;
  totalCount: number;
}

const INITIAL_PAGE = 1;
const INITIAL_LIMIT = 25;

export const useGroupsTab = (): GroupsTabProps => {
  const { user } = useContext(UserContext);

  const [page, setPage] = useState<number>(INITIAL_PAGE);
  const [limit, setLimit] = useState<number>(INITIAL_LIMIT);
  const [sortDirection, setSortDirection] = useState<SortDirection>('asc');
  const [sortBy, setSortBy] = useState<string>('name');

  const { data, loading, refetch } = useQuery(GET_USER_GROUPS_FOR_USER, {
    variables: {
      input: {
        // @ts-ignore
        userId: user?.id,
        page,
        limit,
        sortBy,
        isAscending: sortDirection === 'asc',
      },
    },
    fetchPolicy: 'no-cache',
  });

  return {
    groups: R.pathOr([], ['userUserGroups', 'userUserGroups'], data),
    loadingGroups: loading,
    refetchGroups: refetch,
    page,
    setPage,
    limit,
    setLimit,
    sortDirection,
    setSortDirection,
    sortBy,
    setSortBy,
    totalCount: R.pathOr(0, ['userUserGroups', 'totalCount'], data),
  };
};
